<div class="container">
  <ng-container>
    <app-product-list
      [fixAnyVerdict]="true"
      [hideFilters]="false"
      [skipQueryParams]="false"
      [fixStatusIn]="['approved', 'invited', 'notinvited']"
      [entryWidget]="votingWidget"
      [fixSingleCycle]="true"
      [hideExcelExport]="true"
      [hideBrExport]="true"
      [actionsTemplate]="actions"
      [defaultSort]="'votesDesc'"
      (queryChanged)="queryChanged($event)"
    >
    </app-product-list>
  </ng-container>
</div>

<ng-template #actions>
  <div class="actions">
    <markant-button class="pink button" [disabled]="!cycleId" (click)="openDownloadDialog()">
      <i class="far fa-file-excel"></i>
      Liste</markant-button
    >
    <markant-button *minPrivilege="'FULL'" type="button" class="primary pink button" [disabled]="!cycleId" (click)="openExecuteUpdatesDialog()">
      <i class="far fa-paper-plane"></i>
      Einladen
    </markant-button>
  </div>
</ng-template>

<ng-template #votingWidget let-entry="entry" let-query="query">
  <app-ma-voting-widget [entry]="entry" [query]="query"></app-ma-voting-widget>
</ng-template>
